























































































































































































































































































































































































































































































































//import ExcelJS from 'exceljs';
import Card from "../../components/Card.vue";
import { api } from "../../plugins/api";
import { DateTime } from "luxon";
import { DateFilter } from "~/plugins/filters";

import InadimplentesImpressao from "./inadimplentes/print.vue";
import { inadimplente_repository, Boleto, Filter } from "~/store/inadimplentes";

type Unidade = {
  codigo: number;
  descricao: string;
  adimplente: boolean;
  inadimplente: boolean;
};

type DataType = {
  tipoVisualizacao: string;
  loading: boolean;
  data: string;
  errors: any[];
  boletos: Boleto[] | null;
  codigo_bloco: string;
  codigo_unidade: string;
  periodo: string;
  constantes: Record<string, string>;
  hoje: string;
  data_de: string;
  data_ate: string;
  forma_cobranca: string;
  advogado: string;
  forma_cobranca_selecionada: string;
  advogado_selecionado: string;
};

type FormaCobranca = {
  tipo: "N" | "E" | "J";
  descricao: string;
};

export default {
  components: {
    Card,
    InadimplentesImpressao,
  },
  filters: {},
  data(): DataType {
    return {
      tipoVisualizacao: "detalhado",
      loading: false,
      data: DateTime.local().toFormat("dd/LL/yyyy"),
      errors: [],
      boletos: null,
      codigo_bloco: "",
      codigo_unidade: "",
      constantes: {},
      periodo: "",
      hoje: DateTime.local().toFormat("yyyy-LL-dd"),
      data_de: DateTime.local().toFormat("yyyy-LL-dd"),
      data_ate: DateTime.local().toFormat("yyyy-LL-dd"),
      forma_cobranca: "",
      advogado: "",
      forma_cobranca_selecionada: "",
      advogado_selecionado: "",
    };
  },
  methods: {
    date(value: string | Date | null, format: string = "dd/LL/yyyy"): string {
      return DateFilter(value, format);
    },
    currency(value: number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    async exportToExcel() {
      const Workbook = await import("exceljs").then(e => e.Workbook);
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Inadimplentes");

      // Add headers and data from the no-print section
      worksheet.addRow(["Condomínio", "Abreviação", "Endereço"]);

      const condominioRow = [
        this.condominio.nome,
        this.condominio.abrev,
        this.condominio.endereco.enderecoCompleto,
      ];
      worksheet.addRow(condominioRow);

      worksheet.addRow([]); // Add an empty row for spacing

      // Add headers and data from the no-print section
      worksheet.addRow([
        "Nº Total de  Boletos",
        "R$ Total de Atrasados",
        "R$ Total de Atrasados c/ Multa",
      ]);

      const ResumoRow = [
        this.quantidade_boletos,
        this.total.valor,
        this.total.valorAtualizado,
      ];
      worksheet.addRow(ResumoRow);

      worksheet.addRow([]); // Add an empty row for spacing

      // Add headers for the data from the print section
      const printSectionHeaders = [
        "Nome",
        "Unidade",
        "Tipo",
        "Mês/Ano",
        "Valor",
        "C/Multa",
        "Vencimento",
      ];
      worksheet.addRow(printSectionHeaders);

      // Add data rows from the print section
      this.unidades.forEach(unidade => {
        unidade.boletos.forEach(boleto => {
          const row = [
            boleto.nome,
            unidade.descricao,
            boleto.tipoDOC,
            boleto.competencia,
            boleto.valor,
            boleto.valorAtualizado,
            DateTime.fromISO(boleto.dataVencimento).toFormat("dd/LL/yyyy"),
          ];
          worksheet.addRow(row);
        });

        // Calculate the subtotal
        const subtotalValor = unidade.boletos.reduce(
          (acc, boleto) => acc + boleto.valor,
          0
        );
        const subtotalValorAtualizado = unidade.boletos.reduce(
          (acc, boleto) => acc + boleto.valorAtualizado,
          0
        );

        // Add a row for subtotal
        const subtotalRow = [
          "",
          "",
          "",
          "Subtotal",
          subtotalValor,
          subtotalValorAtualizado,
          "",
        ];
        worksheet.addRow(subtotalRow);
        worksheet.addRow([]); // Add an empty row for spacing
      });

      worksheet.addRow([]); // Add an empty row for spacing

      // Calculate and add a row for the total
      const totalValor = this.unidades.reduce((acc, unidade) => {
        return (
          acc + unidade.boletos.reduce((acc, boleto) => acc + boleto.valor, 0)
        );
      }, 0);
      const totalValorAtualizado = this.unidades.reduce((acc, unidade) => {
        return (
          acc +
          unidade.boletos.reduce(
            (acc, boleto) => acc + boleto.valorAtualizado,
            0
          )
        );
      }, 0);

      const totalRow = [
        "",
        "",
        "",
        "Total",
        totalValor,
        totalValorAtualizado,
        "",
      ];
      worksheet.addRow(totalRow);

      // Generate the Excel file
      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const fileName = `Inadimplentes_${this.condominio.abrev} - ${this.condominio.nome}.xlsx`;

        if ("msSaveOrOpenBlob" in window.navigator) {
          // For IE and Edge
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          // For other browsers
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    print() {
      window.print();
    },
    async loadConstantes() {
      let { data } = await api.get<{ chave: string; valor: any }[]>(
        "/constantes"
      );
      this.constantes = data.reduce<Record<string, any>>((acc, row) => {
        acc[row.chave] = row.valor;
        return acc;
      }, {});
    },
    async loadBoletos() {
      try {
        let params: Filter = {
          codigo_condominio: this.condominio.codigo,
        };
        if ("" != this.codigo_bloco) {
          params.bloco = this.codigo_bloco;
        }
        if ("" != this.codigo_unidade) {
          params.codigo_unidade = +this.codigo_unidade;
        }

        if (this.data_de != this.hoje) {
          params.data_de = this.data_de;
          params.data_ate = this.data_ate;
        }

        const boletos = await inadimplente_repository.search(params);
        /*
                let {
                data: boletos,
                } = await api.get(
                `condominios/${this.condominio.codigo}/inadimplentes`,
                { params }
                );
                */
        this.boletos = boletos;
        this.forma_cobranca_selecionada = "";
        this.advogado_selecionado = "";
      } catch (err) {
        this.errors = [...this.errors, err];
        console.error(err);
      }
    },
    async loadData() {
      this.loading = true;
      this.errors = [];
      this.boletos = null;

      await this.loadBoletos();

      this.forma_cobranca_selecionada = this.forma_cobranca;
      this.advogado_selecionado = this.advogado;

      this.loading = false;
    },
    limpa() {
      this.forma_cobranca_selecionada = "";
      this.advogado_selecionado = "";
      this.forma_cobranca = "";
      this.advogado = "";
    },
  },
  computed: {
    Boletos() {
      if (!this.boletos) {
        return [];
      }

      let boletos = this.boletos.filter(boleto => {
        if (this.forma_cobranca_selecionada !== "") {
          if (
            boleto.unidade.cobranca.tipo !== this.forma_cobranca_selecionada
          ) {
            return false;
          }
        }

        if (this.advogado_selecionado !== "") {
          if (boleto.unidade.cobranca.tipo === "N") {
            return false;
          }

          if (boleto.unidade.cobranca.advogado !== this.advogado_selecionado) {
            return false;
          }
        }

        return true;
      });

      return boletos;
    },
    condominio() {
      return this.$store.getters.condominio;
    },
    formas_cobranca() {
      if (!this.boletos) {
        return [];
      }
      let formas: FormaCobranca[] = this.boletos.map(boleto => {
        let tipo = boleto.unidade.cobranca.tipo;
        if (boleto.unidade.cobranca.tipo === "N") {
          return {
            tipo,
            descricao: "Sem cobrança",
          };
        } else {
          return {
            tipo,
            descricao: boleto.unidade.cobranca.descricao,
          };
        }
      });

      let tipos: Map<string, FormaCobranca> = new Map();
      for (let forma of formas) {
        tipos.set(forma.tipo, forma);
      }

      let resp = Array.from(tipos.values());
      resp.sort((a, b) => {
        if (a.tipo === "N") {
          return -1;
        }
        if (a.tipo === "J" && b.tipo === "E") {
          return -1;
        }
        return 1;
      });
      return resp;
    },
    advogados() {
      if (!this.boletos) {
        return [];
      }
      let advogados = this.boletos.map(boleto => {
        if (boleto.unidade.cobranca.tipo === "N") {
          return "";
        }
        if (this.forma_cobranca !== "") {
          if (boleto.unidade.cobranca.tipo !== this.forma_cobranca) {
            return "";
          }
        }
        return boleto.unidade.cobranca.advogado;
      });

      advogados = [...new Set(advogados)].filter(
        advogado => advogado.trim() != ""
      );

      
      advogados.sort();

      return advogados;
    },
    codigo_condominio() {
      if (!this.condominio) {
        return null;
      }
      return this.condominio.codigo;
    },
    total() {
      return this.unidades.reduce(
        (acc, { subtotal: { valor, valorAtualizado } }) => {
          acc.valor += valor;
          acc.valorAtualizado += valorAtualizado;
          return acc;
        },
        { valor: 0, valorAtualizado: 0 }
      );
    },
    unidades() {
      if (null === this.Boletos) {
        return [];
      }

      function nonEmpty<TValue>(value: TValue): value is NonNullable<TValue> {
        return value !== null && value !== undefined;
      }

      let unidades = this.Boletos.map(({ unidade }) => unidade);
      let Unidades = [...new Set(unidades.map(({ codigo }) => codigo))]
        .map(codigo => unidades.find(u => u.codigo == codigo))
        .map(unidade => {
          if (!unidade) {
            return null;
          }
          let boletos = (this.Boletos || []).filter(
            boleto => boleto.unidade.codigo == unidade.codigo
          );
          let [boleto] = boletos;
          let nome = boleto.nome;
          let subtotal = boletos.reduce(
            (acc, boleto) => {
              acc.valor += boleto.valor;
              acc.valorJMC += boleto.valorJMC;
              acc.valorAtualizado += boleto.valorAtualizado;
              return acc;
            },
            {
              valor: 0,
              valorJMC: 0,
              valorAtualizado: 0,
            }
          );
          return {
            nome,
            ...unidade,
            boletos,
            subtotal,
          };
        })
        .filter(nonEmpty);

      return Unidades;
    },
    quantidade_boletos() {
      let total = 0;
      for (let unidade of this.unidades) {
        total += unidade.boletos.length;
      }
      return total;
    },
    relacao() {
      return this.$store.getters.relacao;
    },
    blocos() {
      if ("undefined" === typeof this.condominio) {
        return [];
      }
      if ("undefined" === typeof this.condominio.blocos) {
        return [];
      }
      let blocos = this.condominio.blocos;
      if ("undefined" != typeof blocos.bloco) {
        blocos = blocos.bloco;
      }
      if (Object.values(blocos).length == 0) {
        blocos = [];
      }
      if (!(blocos instanceof Array)) {
        blocos = [blocos];
      }
      return blocos;
    },
    Unidades() {
      if ("undefined" === typeof this.condominio) {
        return [];
      }
      if ("undefined" === typeof this.condominio.unidades) {
        return [];
      }
      let unidades: Unidade[] | Unidade = this.condominio.unidades;

      if (Object.values(unidades).length == 0) {
        return [];
      }
      if (!(unidades instanceof Array)) {
        unidades = [unidades];
      }
      if ("" != this.codigo_bloco) {
        unidades = unidades.filter(({ descricao }) => {
          let regex = new RegExp(`BLOCO ${this.codigo_bloco}$`, "igm");
          return regex.test(descricao);
        });
      }
      return unidades;
    },
    imovel() {
      return this.$store.getters.imovel;
    },
    codigo_imovel() {
      if (!this.imovel) {
        return 0;
      }
      if (!this.imovel.codigo) {
        return 0;
      }
      return +this.imovel.codigo;
    },
  },
  created() {
    this.loadConstantes();
  },
  watch: {
    codigo_condominio: {
      immediate: true,
      handler() {
        //this.loadData();
        this.codigo_bloco = "";
        this.codigo_unidade = "";
        this.forma_cobranca_selecionada = "";
        this.advogado_selecionado = "";
        this.forma_cobranca = "";
        this.advogado = "";
        this.boletos = null;
      },
    },
    forma_cobranca() {
      this.advogado = "";
    },
    periodo: {
      immediate: true,
      handler(value) {
        let first_date;
        switch (value) {
          case "Mês Atual":
            first_date = DateTime.local();
            first_date = first_date.set({ day: 1 });

            this.data_de = first_date.toFormat("yyyy-LL-dd");
            this.data_ate = first_date
              .plus({ months: 1 })
              .minus({ days: 1 })
              .toFormat("yyyy-LL-dd");
            break;
          case "Mês Anterior":
            first_date = DateTime.local();
            first_date = first_date.set({ day: 1 }).minus({ months: 1 });

            this.data_de = first_date.toFormat("yyyy-LL-dd");
            this.data_ate = first_date
              .plus({ months: 1 })
              .minus({ days: 1 })
              .toFormat("yyyy-LL-dd");
            break;
          default:
            break;
        }
        this.limpa();
      },
    },
    data_de() {
      this.limpa();
    },
    data_ate() {
      this.limpa();
    },
    codigo_bloco() {
      this.codigo_unidade = "";
      this.forma_cobranca_selecionada = "";
      this.advogado_selecionado = "";
      this.forma_cobranca = "";
      this.advogado = "";
    },
    codigo_unidade() {
      this.forma_cobranca_selecionada = "";
      this.advogado_selecionado = "";
      this.forma_cobranca = "";
      this.advogado = "";
    },
  },
};
